import { useRef, useState } from "react";

const useMenuHeight = () => {
  const [menuHeight, setMenuHeight] = useState("0px");
  const menuRef = useRef<HTMLDivElement>(null);

  return {
    menuHeight,
    setMenuHeight,
    menuRef,
  };
};

export default useMenuHeight;
